export enum ActionType {
  GET_LATE_ITEM_STATE_REQUEST = 'report/share/GET_LATE_ITEM_STATE_REQUEST',
  GET_LATE_ITEM_STATE_CACHED = 'report/share/GET_LATE_ITEM_STATE_CACHED',
  GET_LATE_ITEM_STATE_REQUEST_SUCCESS = 'report/share/GET_LATE_ITEM_STATE_REQUEST_SUCCESS',
  GET_LATE_ITEM_STATE_REQUEST_FAILURE = 'report/share/GET_LATE_ITEM_STATE_REQUEST_FAILURE',
}

export type Action = any;
//   | FSA<ActionType.TOKEN_REQUEST>
